import React from 'react';
import LoaderSpinner from './LoaderSpinner';

export default function Loading({ message = 'Loading...' }) {
  return (
    <div className="loading">
      <LoaderSpinner size={24} />
      <p style={{ marginTop: 8, fontSize: 12 }}>{message}</p>
    </div>
  );
}
